export const urljoin = (base: string, relative: string) => {
  return new URL(relative, base.endsWith('/') ? base : base + '/').href;
};
